import axios from 'axios'
import {ResponseObject} from '../../../../../models'
import {GetLayoutDtoModel} from '../models/GetLayoutDto.model'
import {LayoutModel} from '../models/layout.model'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export async function getList(dto: GetLayoutDtoModel) {
  return await axios.post<ResponseObject<LayoutModel[]>>(`${BASEURL}/layout/getList`, dto)
}
